<template>
    <div class="PwSearch">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>비밀번호 찾기</h2>
            <div class="btn_back">
                <a @click="slidePanelClose">
                  <img src="@/assets/images/btn_back.png" width="50" alt="이전" />
                </a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <h2 class="slidePanel-title">비밀번호 찾기 방법을 선택해주세요</h2>
            <div>
                <ul class="li-bottom-line">
                    <li>
                        <span>
                            <label class="rad">
                                <input type="radio"
                                       value="phone"
                                       v-model="searchPwType" />
                                <i></i>
                                가입된 휴대폰 번호로 찾기
                            </label>
                        </span>
                        <div v-show="searchPwType == 'phone'">
                            <div class="form-box">
                                <div class="input-title"><span>아이디</span></div>
                                <div class="input-box">
                                    <div class="input-item">
                                        <input type="text"
                                               placeholder="아이디를 입력해주세요."
                                               v-model="searchPhoneId" />
                                    </div>
                                </div>
                            </div>
                            <transition name="fade">
                              <p class="error-msg"
                                 v-show="errorField == 'strUserId'">
                                {{errorMsg}}
                              </p>
                            </transition>
                            <div class="form-box">
                                <div class="input-title"><span>이름</span></div>
                                <div class="input-box">
                                    <div class="input-item">
                                        <input type="text"
                                               placeholder="이름을 입력해주세요."
                                               v-model="searchPhoneName" />
                                    </div>
                                </div>
                            </div>
                            <transition name="fade">
                                <p class="error-msg"
                                   v-show="errorField == 'strName'">
                                  {{errorMsg}}
                                </p>
                            </transition>
                            <div class="form-box">
                                <div class="input-title"><span>휴대전화</span></div>
                                <div class="input-box">
                                    <div class="input-item input-item-phone">
                                        <select v-model="searchPhoneNumber1">
                                            <option value="">선택</option>
                                            <option>010</option>
                                            <option>011</option>
                                            <option>016</option>
                                            <option>017</option>
                                            <option>018</option>
                                            <option>019</option>
                                        </select>
                                    </div>
                                    <span class="input-text">-</span>
                                    <div class="input-item">
                                        <input type="text"
                                               pattern="\d*"
                                               placeholder=""
                                               v-model.number="searchPhoneNumber2"
                                               v-mask="['########','#######']"
                                               inputmode="numeric" />
                                    </div>
                                </div>
                            </div>
                            <transition name="fade">
                                <p class="error-msg"
                                   v-show="errorField == 'strPhoneNumber1' || errorField == 'strPhoneNumber2'">
                                  {{errorMsg}}
                                </p>
                            </transition>
                        </div>
                    </li>
                    <li>
                        <span>
                            <label class="rad">
                                <input type="radio"
                                       value="email"
                                       v-model="searchPwType" />
                                <i></i>
                                가입된 이메일로 찾기
                            </label>
                        </span>
                        <div class="pdd-btm-20"
                             v-show="searchPwType == 'email'">
                            <div class="form-box">
                                <div class="input-title"><span>아이디</span></div>
                                <div class="input-box">
                                    <div class="input-item">
                                        <input type="text"
                                               placeholder="아이디를 입력해주세요."
                                               v-model="searchEmailId" />
                                    </div>
                                </div>
                            </div>
                            <transition name="fade">
                                <p class="error-msg"
                                   v-show="errorField == 'strUserId'">
                                    {{errorMsg}}
                                </p>
                            </transition>
                            <div class="form-box">
                                <div class="input-title"><span>이름</span></div>
                                <div class="input-box">
                                    <div class="input-item">
                                        <input type="text"
                                               placeholder="이름을 입력해주세요."
                                               v-model="searchEmailName" />
                                    </div>
                                </div>
                            </div>
                            <transition name="fade">
                                <p class="error-msg" v-show="errorField == 'strName'">
                                    {{errorMsg}}
                                </p>
                            </transition>
                            <div class="form-box">
                                <div class="input-title"><span>이메일</span></div>
                                <div class="input-box">
                                    <div class="input-item">
                                        <input type="text"
                                               placeholder="이메일 주소를 입력해주세요."
                                               v-model="searchEmailEmail" />
                                    </div>
                                </div>
                            </div>
                            <transition name="fade">
                                <p class="error-msg"
                                   v-show="errorField == 'strEmail'">
                                  {{errorMsg}}
                                </p>
                            </transition>
                        </div>
                    </li>
                    <li>
                        <span>
                            <label class="rad">
                                <input type="radio"
                                       value="birthday"
                                       v-model="searchPwType" />
                                <i></i>
                                가입된 대표님 생년월일로 찾기
                            </label>
                        </span>
                        <div class="pdd-btm-20"
                             v-show="searchPwType == 'birthday'">
                            <div class="form-box">
                                <div class="input-title"><span>아이디</span></div>
                                <div class="input-box">
                                    <div class="input-item">
                                        <input type="text"
                                               placeholder="아이디를 입력해주세요."
                                               v-model="searchBirthdaylId" />
                                    </div>
                                </div>
                            </div>
                            <transition name="fade">
                                <p class="error-msg"
                                   v-show="errorField == 'strUserId'">
                                    {{errorMsg}}
                                </p>
                            </transition>
                            <div class="form-box">
                                <div class="input-title"><span>이름</span></div>
                                <div class="input-box">
                                    <div class="input-item">
                                        <input type="text"
                                               placeholder="이름을 입력해주세요."
                                               v-model="searchBirthdayName" />
                                    </div>
                                </div>
                            </div>
                            <transition name="fade">
                                <p class="error-msg"
                                   v-show="errorField == 'strName'">
                                  {{errorMsg}}
                                </p>
                            </transition>
                            <div class="form-box">
                                <div class="input-title"><span>생년월일</span></div>
                                <div class="input-box">
                                    <div class="input-item">
                                        <input type="text"
                                               placeholder=""
                                               pattern="\d*"
                                               v-model.number="searchBirthdayBirth1"
                                               v-mask="'####'"
                                               inputmode="numeric" />
                                    </div>
                                    <div class="input-item">
                                        <select v-model="searchBirthdayBirth2">
                                            <option value="" selected>월</option>
                                            <option v-for="index in 12"
                                                    :key="index"
                                                    :value="index | leftPad(2)">
                                              {{ index }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="input-item">
                                        <select v-model="searchBirthdayBirth3">
                                            <option value="" selected>일</option>
                                            <option v-for="index in 31"
                                                    :key="index"
                                                    :value="index | leftPad(2)">
                                              {{ index }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <transition name="fade">
                                <p class="error-msg"
                                     v-show="errorField == 'strBirthYear' ||
                                              errorField == 'strBirthMonth' ||
                                              errorField == 'strBirthDay'">
                                      {{errorMsg}}
                                </p>
                            </transition>
                        </div>
                    </li>
                </ul>
                <div class="mrg-top-40 mrg-btm-20">
                    <button class="btn-big btn-bule"
                            @click="formSendFunc">
                      비밀번호 찾기
                    </button>
                </div>
                <div class="info-msg mrg-btm-40">
                    아이디가 기억나지 않으시면<br />
                    <a @click.prevent="idFindSlideView">아이디 찾기</a>를 선택해주세요.
                </div>
            </div>
        </div>
        <!-- s: contents -->
    </div>
</template>

<script>

export default {
    name: 'PwSearch',
    props: ['pStrUserId'],
    data() {
        return {
            searchPwType:'',          // 선택된 Tab

            searchPhoneId:'',         // 아이디
            searchPhoneName:'',       // 이름
            searchPhoneNumber1:'',    // 휴대폰 번호 - 식별번호
            searchPhoneNumber2:'',    // 휴대폰 번호 - 고유번호

            searchEmailId:'',         // 아이디
            searchEmailName:'',       // 이름
            searchEmailEmail:'',      // 이메일 주소

            searchBirthdaylId:'',     // 아이디
            searchBirthdayName:'',    // 이름
            searchBirthdayBirth1:'',  // 생년월일 (년도)
            searchBirthdayBirth2:'',  // 생년월일 (월)
            searchBirthdayBirth3:'',  // 생년월일 (일)

            errorField:'',            // error 항목
            errorMsg:'',              // error 메시지

            isOpening:false,          // 슬라이드팝업 오픈 체크
        }
    },
    // 감시자
    watch: {
        // radio 변경
        searchPwType(_new){
            if (_new){
                this.errorField = '';
                this.errorMsg = '';

                if(!this.pStrUserId){
                    this.searchPhoneId = '';
                    this.searchEmailId = '';
                    this.searchBirthdaylId = '';
                }

                this.searchPhoneName = '';
                this.searchPhoneNumber1 = '';
                this.searchPhoneNumber2 = '';

                this.searchEmailName = '';
                this.searchEmailEmail = '';

                this.searchBirthdayName = '';
                this.searchBirthdayBirth1 = '';
                this.searchBirthdayBirth2 = '';
                this.searchBirthdayBirth3 = '';
            }
        },
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
        this.searchPhoneId = this.pStrUserId;
        this.searchEmailId = this.pStrUserId;
        this.searchBirthdaylId = this.pStrUserId;
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 비밀번호 찾기
        formSendFunc(){
            if (!this.searchPwType){
                this.toastMsg('비밀번호 찾기 방법을 선택해주세요',1500);
                return false;
            }

            let formData = new FormData();
            if (this.searchPwType == 'phone'){
                formData.append('strUserId', this.searchPhoneId);
                formData.append('strName', this.searchPhoneName);
                formData.append('strPhoneNumber1', this.searchPhoneNumber1);
                formData.append('strPhoneNumber2', this.searchPhoneNumber2);

            }else if (this.searchPwType == 'email'){
                formData.append('strUserId', this.searchEmailId);
                formData.append('strName', this.searchEmailName);
                formData.append('strEmail', this.searchEmailEmail);

            }else if (this.searchPwType == 'birthday'){
                formData.append('strUserId', this.searchBirthdaylId);
                formData.append('strName', this.searchBirthdayName);
                formData.append('strBirthYear', this.searchBirthdayBirth1);
                formData.append('strBirthMonth', this.searchBirthdayBirth2);
                formData.append('strBirthDay', this.searchBirthdayBirth3);
            }
            this.ajaxPost('/api/v1/find/password/'+this.searchPwType, formData,this.formSendFuncResult);
        },
        // 비밀번호 찾기 결과
        formSendFuncResult(response){
            let result = response.result;
            if (result.code == 0){
                this.errorField = '';
                this.errorMsg = '';
                this.pwFindResultSlideView(response.oMemberInfo)
            }else{
                this.errorMsg=result.resultNoti.message;
                this.errorField=result.resultNoti.validationFail.id;
            }
        },
        // 비밀번호 결과 화면
        pwFindResultSlideView(result){
            let props = {
                pResult : result,
            };
            const panel =this.$showPanel({
                component: () => import('./PwSearchResult.vue'),
                props: props,
                openOn: 'right',
                width:screen.width,
            });
            panel.promise.then(result => {
                window.callbackBackKey = this.callbackBackKey;
                if (result.result === "close"){
                    this.slidePanelClose(result);
                }
            });
        },
        // 아이디 찾기 Slide
        idFindSlideView(){
            // 더블클릭 방지 체크
            if (this.isOpening){
                return false;
            }

            this.isOpening = true;

            setTimeout(() => {
                this.slidePanelClose();
                const panel =this.$showPanel({
                    component: () => import('./IdSearch.vue'),
                    openOn: 'right',
                    width:screen.width,
                });
                panel.promise.then(result => {
                    window.callbackBackKey = this.callbackBackKey;
                    if (result.userId) this.userId = result.userId;
                });

                this.isOpening = false;
            }, 300);


        }
    }
}
</script>

<style scoped>
</style>
